module.exports = __webpack_public_path__ + "media/images/mobile/solutions/19-675e4aae75ebc85867a3fa851274d8f5.png";